const routes = [
    {
        path: '',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                path: '/area_cliente/notas_fiscais',
                component: () => import('../views/Listar')
            }
        ]
    }
]

export default routes
